import React, { useState } from "react";
// import { maintenanceGeneralData } from "../../../../fakeData/maintenanceGeneralData";
//import { maintenanceGuestData } from "../../../../fakeData/maintenanceGuestData";
import { AddBox, Search } from "@mui/icons-material";

import maintenanceGeneralData from "../../../../fakeData/maintenanceGeneralData";
import maintenanceGuestData from "../../../../fakeData/maintenanceGuestData";
import "devextreme/data/odata/store";

import Maintenance from "../../../../components/customComponents/Maintenance";
import { Card, Col, Row } from "react-bootstrap";
import { DataGrid } from "devextreme-react";
import { Pager, Paging } from "devextreme-react/data-grid";
import FieldSelector from "../../../../components/customComponents/FieldSelector";

export default function Checkin() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [model, setModel] = useState({
    title: "Reservation Data Entry",
    sections: [
      maintenanceGeneralData,
      maintenanceGuestData,
      //  maintenanceRoomsData,
      // maintenanceChargesData,
      //maintenanceFilesData,
      //maintenanceHistoryData
    ],
    data: {
      Title: "Reservation List",
      Filters: [
        {
          title: "Parent Reservation #",
          value: "",
          htmlType: "text",
          required: true,
          cssClass: "col-12 col-md-4",
          placeholder: "Customer",
          name: "customer",
        },
        {
          title: "Reservation #",
          value: "",
          htmlType: "text",
          required: true,
          cssClass: "col-12 col-md-4",
          placeholder: "Reservation #",
          name: "reservationId",
        },
        {
          title: "Parent Reservation #",
          value: "",
          htmlType: "text",
          required: true,
          cssClass: "col-12 col-md-4",
          placeholder: "Parent Reservation #",
          name: "parentReservationNo",
        },

        {
          title: "Booking Number",
          value: "",
          htmlType: "text",
          required: false,
          cssClass: "col-12 col-md-4 ",
          placeholder: "Booking Number",
          name: "BookingNumber",
        },
      ],
      Columns: [
        "Business Unit",
        "Customer",
        "Currency",
        "Folio Type",
        "Date Start",
        "Date End",
        "Confirmation Number",
        "Booking Date",
        "Booking Number",
        "Blocked",
        "Balance Limit",
        "Voucher",
        "Status",
      ],
      Rows: [
        {
          BusinessUnit: "TROPICAL",
          Customer: "TURAVIA",
          Currency: "USD",
          FolioType: "MASTER",
          DateStart: "23/10/2023",
          DateEnd: "24/10/2023",
          ConfirmationNumber: "69874862",
          BookingDate: "24/10/2023",
          BookingNumber: "BKN987521/009-0426",
          Blocked: "YES",
          BalanceLimit: "30,500.00",
          Voucher: "345987563",
          Status: "PENDING",
        },
        {
          BusinessUnit: "TROPICAL",
          Customer: "EXPEDIA",
          Currency: "USD",
          FolioType: "HOUSE USE",
          DateStart: "24/10/2023",
          DateEnd: "25/10/2023",
          ConfirmationNumber: "698374862",
          BookingDate: "25/10/2023",
          BookingNumber: "BKN987521/009-0426",
          Blocked: "YES",
          BalanceLimit: "20,500.00",
          Voucher: "3459871563",
          Status: "PENDING",
        },
      ],
    },
  });

  const allowedPageSizes = [8, 12, 20];
  const dataUI = () => {
    return (
      <div className="">
        <Card className="mb-4">
          <Card.Header>
            <Card.Title>Filters</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              {model.data.Filters.map((item, index) => {
                return (
                  <Col className={item.cssClass} key={index}>
                    <FieldSelector model={item} key={index}></FieldSelector>
                  </Col>
                );
              })}
            </Row>
          </Card.Body>
          <Card.Footer className="text-end">
            <button className="btn btn-sm btn-primary">
              <Search />
            </button>
          </Card.Footer>
        </Card>
        <Card>
          <Card.Header>
            <Card.Title>{model.data.Title}</Card.Title>
          </Card.Header>
          <Card.Body>
            <DataGrid
              dataSource={model.data.Rows}
              columnAutoWidth={true}
              showBorders={true}
            >
              <Paging defaultPageSize={12} />
              <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
              />
            </DataGrid>
          </Card.Body>
        </Card>
      </div>
    );
  };

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <React.Fragment>
      <div className="row mx-0">
        <div className="col-12">
          <div className="dx-card my-4 px-3 py-2">
            <div className="row">
              <div className="col">
                <h5 className={"mt-2"}>Check-In</h5>
              </div>
              <div className="col text-end">
                <button className="btn">
                  <Search />
                </button>
                <button className="btn" onClick={() => toggleOpen()}>
                  <AddBox />
                </button>
              </div>
            </div>
          </div>
          {open ? (
            <div className="card">
              <div className="card-header">
                <h4>{model.title}</h4>
              </div>
              <div className="card-body p-4">
                <ul class="nav nav-tabs mb-4" id="myTab" role="tablist">
                  {model.sections.map((item, index) => {
                    return (
                      <li key={index} className="nav-item">
                        <button
                          className={
                            "nav-link " +
                            (index === selectedTab ? "active" : "")
                          }
                          onClick={() => {
                            setSelectedTab(index);
                          }}
                        >
                          {item.title}
                        </button>
                      </li>
                    );
                  })}
                </ul>
                <div class="tab-content" id="myTabContent">
                  {model.sections.map((item, index) => {
                    return (
                      <div
                        class={
                          "tab-pane fade " +
                          (index === selectedTab ? "show active" : "")
                        }
                        key={index}
                      >
                        <Maintenance model={item} toggle={toggleOpen} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            dataUI()
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
